const HOST_URL_IMAGE = "https://survey.besins-healthcare.vn/";

export default HOST_URL_IMAGE;
